import * as React from 'react';
import Stack from '@mui/material/Stack';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SettingsIcon from '@mui/icons-material/Settings';
import { CrossStartUpdater } from './CrossStartUpdater';

export default function CrossStartUpdateModal({
  liftSelectedSession,
  selectedSession,
  combinedStates,
}) {
  const [bannerOpen, setBannerOpen] = React.useState(false);

  const toggleBanner = () => {
    setBannerOpen(!bannerOpen);
  };

  return (
    <React.Fragment>
      <TrapFocus open disableAutoFocus disableEnforceFocus>
        <Fade appear={false} in={bannerOpen}>
          {/* <Button>click</Button> */}
          <Paper
            role="dialog"
            aria-modal="false"
            aria-label="Cookie banner"
            square
            variant="outlined"
            tabIndex={-1}
            sx={{
              border: 'solid 3px red',
              height: 40,
              width: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 100,
              display: 'flex',
            }}
          >
            <Box>
              segment: {combinedStates.segment} segmentDistance:{' '}
              {combinedStates.segmentDistance * 1000}
            </Box>
            <CrossStartUpdater
              liftSelectedSession={liftSelectedSession}
              selectedSession={selectedSession}
              combinedStates={combinedStates}
            />
            {/* <Stack
              direction={{ xs: 'column', sm: 'row' }}
              justifyContent="space-between"
              gap={2}
            >
              <Box
                sx={{
                  flexShrink: 1,
                  alignSelf: { xs: 'flex-start', sm: 'center' },
                }}
              >
                <Typography fontWeight="bold">
                  This website uses cookies
                </Typography>
                <Typography variant="body2">
                  example.com relies on cookies to improve your experience.
                </Typography>
              </Box>
              <Stack
                gap={2}
                direction={{
                  xs: 'row-reverse',
                  sm: 'row',
                }}
                sx={{
                  flexShrink: 0,
                  alignSelf: { xs: 'flex-end', sm: 'center' },
                }}
              >
                <Button size="small" onClick={closeBanner} variant="contained">
                  Allow all
                </Button>
                <Button size="small" onClick={closeBanner}>
                  Reject all
                </Button>
              </Stack>
            </Stack> */}
          </Paper>
        </Fade>
      </TrapFocus>
      <Button
        onClick={toggleBanner}
        sx={{
          //   border: 'solid 3px orange',
          height: 40,
          width: 40,
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 200,
        }}
      >
        <SettingsIcon />
      </Button>
    </React.Fragment>
  );
}
